import { AiTextStyle } from '../types/ai';

export class AiCanvas {
  public readonly canvas: HTMLCanvasElement;
  public readonly context: CanvasRenderingContext2D;
  #quality = 1;

  private constructor() {
    this.canvas = document.createElement('canvas');
    this.context = this.canvas.getContext('2d')!;
  }

  public static create(props?: { width: number; height: number }) {
    const aiCanvas = new AiCanvas();
    aiCanvas.canvas.width = props?.width || 0;
    aiCanvas.canvas.height = props?.height || 0;
    return aiCanvas;
  }

  public drawOriginal(
    // eslint-disable-next-line no-undef
    image: CanvasImageSource,
    coordX: number,
    coordY: number
  ) {
    this.context.drawImage(
      image,
      coordX,
      coordY,
      this.canvas.width,
      this.canvas.height
    );

    return this;
  }

  public drawAiImage(
    // eslint-disable-next-line no-undef
    image: CanvasImageSource,
    coordX: number,
    coordY: number,
    width: number,
    height: number
  ) {
    this.context.drawImage(image, coordX, coordY, width, height);

    return this;
  }

  public applyTextStyles(textStyle: AiTextStyle) {
    textStyle = {
      weight: textStyle?.weight || 'bold',
      family: textStyle?.family || 'serif',
      size: textStyle?.size || '24px',
      color: textStyle?.color || '#000000',
      baseline: textStyle?.baseline || 'middle',
      scaleSize: textStyle?.scaleSize,
    };
    let size = textStyle.size;

    if (textStyle.scaleSize) {
      const aiWidth = this.canvas.width * textStyle.scaleSize;
      const aiHeight = this.canvas.height * textStyle.scaleSize;
      size = `${Math.floor(Math.min(aiWidth, aiHeight) * textStyle.scaleSize)}px`;
    }

    this.context.fillStyle = textStyle.color!;
    this.context.textBaseline = textStyle.baseline!;
    this.context.font = `${textStyle.weight} ${size} ${textStyle.family}`;

    return this;
  }

  public drawAiText(text: string, coordX: number, coordY: number) {
    this.context.fillText(text, coordX, coordY);

    return this;
  }

  public result(resolve: (value: Blob | PromiseLike<Blob>) => void) {
    this.context.canvas.toBlob(
      (_blob) => {
        resolve(_blob!);
      },
      'image/jpeg',
      this.#quality
    );
  }
}
